import cx from "classnames";
/* UTILS */
import t, { AsHtml } from "../../../../../utils/translate";
import { NONE } from "../../../constants";
import applangaKeyMap from "./applangaKeyMap";
/* COMPONENTS */
import useAppContext from "components/AppContext";
import Column from "../../../../Column";
import Break from "../../../../ClinicCheckout/Payment/componets/Break";
import BulletItem from "components/BulletItem";
import OfferTag from "../OfferTag";
/* STYLES */
import styles from "./styles.module.scss";

const MedsCard = ({ urlParam = NONE }) => {
  const { newQuiz } = useAppContext();
  const { headline, subheading, details, img, offer } =
    applangaKeyMap[urlParam] || {};

  const renderBulletItems = () => {
    return applangaKeyMap[urlParam].bulletlist.map((item, i) => (
      <BulletItem key={i}>{t(`${item}`)}</BulletItem>
    ));
  };

  return (
    <Column
      className={cx(styles.content, {
        [styles.hasBackground]: !newQuiz.isClinical,
        [styles.hasCards]: newQuiz.isClinical
      })}
    >
      {!newQuiz.isClinical && urlParam !== NONE && (
        <h2 className={styles.title}>{t("CLINIC_CHECKOUT_YOU_CHOSE")}</h2>
      )}
      {newQuiz.isClinical && (
        <h2 className={styles.header}>
          {t("CLINIC_CHECKOUT_PROGRAM_HEADING")}
        </h2>
      )}
      <div
        className={cx(styles.upperWrapper, {
          [styles.hasBorder]: newQuiz.isClinical
        })}
      >
        <div className={styles.textColumn}>
          <div className={styles.headline}>{t(headline)}</div>
          <div className={styles.subheading}>{t(subheading)}</div>
          <div className={styles.details}>
            <AsHtml value={t(details)} />
          </div>
        </div>
        <div className={styles.ellipseColumn}>
          <img src={img} className={styles.img} alt="" />
        </div>
      </div>
      {!newQuiz.isClinical && <Break />}
      <div
        className={cx(styles.lowerWrapper, {
          [styles.hasBorder]: newQuiz.isClinical
        })}
      >
        <div className={styles.checklist}>
          <div className={styles.checklistTitle}>{t("CHECKLIST_INCLUDES")}</div>
          <div className={styles.checklistItems}>{renderBulletItems()}</div>
        </div>
        {offer && <OfferTag {...offer} />}
      </div>
    </Column>
  );
};

export default MedsCard;
